"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVaultAuctionData = exports.getVaultData = void 0;
const flex_1 = require("../flex/flex");
const vault_1 = require("./vault");
const spl_token_1 = require("@solana/spl-token");
const utils = __importStar(require("../common/utils"));
async function getVaultData(connection, vault) {
    let vaultInfo = vault_1.vault.getVault(vault);
    let vaultUnderlyingTokenAccount = await (0, spl_token_1.getAccount)(connection, vaultInfo.vaultUnderlyingTokenAccount);
    let totalBalance = Number(vaultUnderlyingTokenAccount.amount);
    let userData = [];
    // If the option is initialized, we know that a portion of the vault balance is in the option collateral.
    if (vaultInfo.option !== null) {
        let optionVault = await (0, spl_token_1.getAccount)(connection, vaultInfo.option.vault);
        totalBalance += Number(optionVault.amount);
    }
    let redeemableMint = await (0, spl_token_1.getMint)(connection, vaultInfo.redeemableMint);
    let underlyingMint = await (0, spl_token_1.getMint)(connection, vaultInfo.underlyingMint);
    // Price per share = total vault balance / redeemable mint supply
    let pricePerShare = (totalBalance / Number(redeemableMint.supply)) *
        (10 ** redeemableMint.decimals / 10 ** underlyingMint.decimals);
    let tokenAccounts = await utils.getTokenAccountsForMint(connection, vaultInfo.redeemableMint);
    let mint = await (0, spl_token_1.getMint)(connection, vaultInfo.redeemableMint);
    for (var i = 0; i < tokenAccounts.length; i++) {
        let account = tokenAccounts[i];
        let userUnderlyingBalance = (account.amount.toNumber() / Number(mint.supply)) * totalBalance;
        userData.push({
            vault: vaultInfo.address,
            user: account.owner,
            lockedUnderlyingAmount: userUnderlyingBalance,
        });
    }
    return {
        name: vaultInfo.vaultName,
        address: vaultInfo.address,
        totalBalance,
        depositLimit: vaultInfo.depositLimit,
        pricePerShare,
        epochSequenceNumber: vaultInfo.epochSequenceNumber,
        vaultUserData: userData,
    };
}
exports.getVaultData = getVaultData;
async function getVaultAuctionData(vault) {
    await vault_1.vault.updateState();
    let auctionData = [];
    let vaultInfo = vault_1.vault.getVault(vault);
    let auctions = flex_1.flex.getAuctionsByCreator(vault_1.vault.vaultAuthority);
    let filteredAuctions = [];
    auctions.map((auction) => {
        // Find the auctions that match the vault's underlying token.
        if (auction.bidCurrencyMint.equals(vaultInfo.underlyingMint)) {
            filteredAuctions.push(auction);
        }
    });
    for (var i = 0; i < filteredAuctions.length; i++) {
        let auction = filteredAuctions[i];
        let optionInfo = auction.optionInfo;
        if (auction.exchangeAmount == 0) {
            continue;
        }
        auctionData.push({
            vault: vaultInfo.address,
            auction: auction.address,
            underlyingCollateral: optionInfo.collateralAmount,
            numOptionsMinted: auction.amount,
            premiumCollected: auction.exchangeAmount,
            strike: optionInfo.strike,
            expiry: optionInfo.expiry,
        });
    }
    return auctionData;
}
exports.getVaultAuctionData = getVaultAuctionData;
